import { rootApi } from '../../../root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    fetchSeatRequest: build.query({
      query: (uuid) => ({ url: `/api/seat_requests/${uuid}` })
    }),
    submitSeatRequestDecline: build.mutation({
      query: ({ uuid, emailBody }) => ({
        url: `/api/seat_requests/${uuid}`,
        method: 'PATCH',
        data: {
          email_body: emailBody
        }
      })
    })
  })
})

export const { useFetchSeatRequestQuery, useSubmitSeatRequestDeclineMutation } = api
